const CompetitionSelectSelectors = {
  getCompetitionSelect(store) {
    return store.competitionSelect;
  },
};

export { CompetitionSelectSelectors };
